import React from 'react';
// import PropTypes from 'prop-types';
// import './cardUserInterface.css'; // Optional: Add styles here
import { Button, ButtonGroup, Card, Grid, Hidden, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        background: 'white',
        border: '1px solid rgba(0,0,0,0.1)',
        // Opacity: 0.9,
        minWidth: 110,
        padding: '5px 0px',
        margin: 3,
        borderRadius: 3
    },
    CardRoot: {
        width: '100%',
        margin: 3,
        border: '2px solid white ',
        Opacity: 0.9,
        minWidth: 120,
        padding: '5px 0px',
        background: 'white',
        borderRadius: 10
    }
}));

const CardUserInterface = ({ branchDropDown, branchValue, title, titleValue, mainList = [], titleClick, branchClick, bodyClick, hideBranch, mainTitle }) => {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            {mainTitle && (
                <Grid item xs={12} style={{ padding: '5px 5px' }}>
                    <div
                        style={{
                            textAlign: 'left',
                            padding: '0px 10px',
                            fontFamily: `Inter, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
                            fontWeight: 500
                        }}
                    >
                        {mainTitle}
                    </div>
                </Grid>
            )}
            <Hidden only={['xs']}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={8}>
                        <div
                            style={{
                                margin: '10px 10px',
                                textAlign: 'left'
                            }}
                        >
                            <ButtonGroup color="secondary" ria-label="outlined primary button group" size="small">
                                {title.map((n) => {
                                    return (
                                        <Button
                                            variant={titleValue === n.id ? 'contained' : 'outlined'}
                                            onClick={() => titleClick(n.id)}
                                            style={{ fontSize: 10 }}
                                        >
                                            {n.name}
                                        </Button>
                                    );
                                })}
                            </ButtonGroup>
                        </div>
                    </Grid>
                    {!hideBranch && (
                        <Grid item xs={12} sm={4}>
                            <div
                                style={{
                                    float: 'right',
                                    margin: 10
                                }}
                            >
                                <select onChange={branchClick} className="selectclass" value={branchValue}>
                                    <option value={'Default'}>All Branches</option>
                                    {branchDropDown.map((btn, i) => {
                                        return (
                                            <option key={i} value={btn.name}>
                                                {btn.name}{' '}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <div
                            style={{
                                margin: '0px 20px',
                                textAlign: 'left'
                            }}
                        >
                            <span className="lableFont">Dates</span>
                            <select
                                color="secondary"
                                onChange={titleClick}
                                aria-label="outlined primary button group"
                                size="small"
                                className="ButtonDropDown"
                                value={titleValue}
                            >
                                {title.map((n, i) => {
                                    return (
                                        <option key={i} value={n.id}>
                                            {n.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                    {!hideBranch && (
                        <Grid item xs={12}>
                            <div
                                style={{
                                    margin: '0px 20px',
                                    textAlign: 'left'
                                }}
                            >
                                <span className="lableFont">Branch</span>
                                <select onChange={branchClick} className="selectclass" value={branchValue}>
                                    <option value={'Default'}>All Branches</option>
                                    {branchDropDown.map((btn, i) => {
                                        return (
                                            <option key={i} value={btn.name}>
                                                {btn.name}{' '}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </Hidden>

            <Grid item xs={12} style={{ padding: '5px 5px' }}>
                <div
                    style={{
                        textAlign: 'left',
                        padding: '0px 20px',
                        fontFamily: ` Inter, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
                        fontWeight: 500
                    }}
                ></div>
            </Grid>

            <div style={{ padding: '0px 30px' }}>
                <hr
                    style={{
                        flexShrink: 0,
                        borderWidth: '0px 0px thin',
                        borderStyle: 'solid',
                        borderColor: 'rgba(58, 53, 65, 0.12)',
                        margin: '2px 0px 10px 0px'
                    }}
                />
            </div>
            <Grid container spacing={1} style={{ padding: '0px 20px' }}>
                {mainList.length > 0 ? (
                    mainList.map((item, index) => (
                        <Grid item xs={6} sm={2} style={{ padding: '5px 5px' }} onClick={() => bodyClick(item)}>
                            <div
                                style={{
                                    borderLeft: item.BarColor || '5px solid lightgreen',
                                    padding: '5px 0px 0px 20px',
                                    width: '100%',
                                    cursor: 'pointer'
                                }}
                            >
                                <div
                                    style={{
                                        paddingRight: 20,
                                        paddingBottom: 5,
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">{item.label || 'Not Set'}</span>
                                    <div className="valueFont">{item.value || 0}</div>
                                </div>
                            </div>
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Alert severity="warning">No Record Found</Alert>
                    </Grid>
                )}
            </Grid>
        </Card>
    );
};

export default CardUserInterface;
